import React from "react";
import { useTranslation } from "react-i18next";

export default function PlanCard({
  price,
  currencySymbol,
  periodLabel,
  seatsLabel,

  isSelected = false,
  isFeatured = false,
  badge,
  savings,
  onClick,
  className = "",
}) {
  const showBadge = isFeatured || isSelected;
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex flex-col items-start text-left cursor-pointer transition-all duration-150 gap-0.5 rounded-[20px] relative ${
        isSelected
          ? "p-[26px_18px_22px] bg-white !border-2 !border-solid !border-brand-orange shadow-[0_12px_28px_-18px_rgba(235,84,56,0.7)]"
          : isFeatured
            ? "p-[26px_18px_22px] bg-surface-option !border-[1.5px] !border-solid !border-[#E3DCD1]"
            : "p-5 px-[18px] pb-[22px] bg-surface-option !border-[1.5px] !border-solid !border-[#E3DCD1]"
      } ${className}`}
    >
      {showBadge && (
        <span
          className={`absolute -top-3 left-4 px-[11px] py-[5px] rounded-full font-bold text-[11px] tracking-[0.05em] uppercase whitespace-nowrap ${
            isSelected
              ? "bg-brand-orange text-white"
              : "bg-border-default text-text-body"
          }`}
        >
          {badge || (isSelected ? "Selected" : "")}
        </span>
      )}

      <span className="font-bold text-[26px] tracking-[-0.02em]">
        {currencySymbol}
        {price}
      </span>
      <span className="text-[13px] text-text-light">{periodLabel}</span>
      <span className="font-bold text-[15px] leading-[1.35] mt-1">
        {seatsLabel} {""}
        {t("pre_cancel.additional_users")}
      </span>

      <span className="text-[13px] leading-[1.45] text-text-body mt-1">
        {t("pre_cancel.at_no_charge")}
      </span>

      {savings && (
        <span
          className=" px-[11px] py-[5px] rounded-lg font-bold text-[11px] tracking-[0.05em]  whitespace-nowrap  text-black bg-text-light-gray mt-2  opacity-60
        "
        >
          {t("pre_cancel.save_over", { savings })}
        </span>
      )}
    </button>
  );
}
